export default __webpack_public_path__ + "static/media/twitter.d0b8bacc.svg";